import MaterialTable from '@material-table/core'
import Permission from '@constants/permission'
import React, { ReactElement, useEffect } from 'react'
import hasPerms from '@utils/has-permission'
import useSelector from '@hooks/use-selector'
import {
  AppDispatch,
  NewPromotionalCategoryType,
  PromotionalCategoryType,
} from '@types'
import {
  createTaxCategory,
  deleteTaxCategory,
  getTaxCategories,
  updateTaxCategory,
} from '@store/actions/tax-categories'
import { selectTaxCategories } from '@store/selectors/tax-categories'
import { useDispatch } from 'react-redux'

const TaxCategories = (): ReactElement => {
  const categories = useSelector(selectTaxCategories)
  const canEdit = hasPerms(Permission.TAX_RATES_UPDATE)
  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(getTaxCategories())
  }, [])

  const handleUpdate = async (category: PromotionalCategoryType) => {
    dispatch(updateTaxCategory(category))
  }

  const handleCreate = async (newCategory: NewPromotionalCategoryType) => {
    dispatch(createTaxCategory(newCategory))
  }

  const handleDelete = async (category: PromotionalCategoryType) => {
    dispatch(deleteTaxCategory(category))
  }

  return (
    <MaterialTable
      columns={[{ title: 'Name', field: 'name' }]}
      data={categories}
      editable={
        canEdit
          ? {
              onRowUpdate: handleUpdate,
              onRowAdd: handleCreate,
              onRowDelete: handleDelete,
            }
          : {}
      }
      options={{
        actionsColumnIndex: 99,
        paging: false,
        addRowPosition: 'first',
        tableLayout: 'fixed',
        search: false,
      }}
      title='Tax Categories'
    />
  )
}

export default TaxCategories
